'use client';

import { type HTMLAttributes, useMemo } from 'react';

import { cn } from '@/libs';
import { MY_PRIZES_VALUES } from '@/mocks/myPrizesExample';

import { processPrizesWithBigGain } from './utils';

import { Button, Carousel } from '../ui';

type PrizeItem = {
  value: string;
  is_big_gain: boolean;
  name?: string;
  type?: string;
  isDrawn?: boolean;
  prizeUrls?: string;
  prizeValue?: number;
};

type MyPrizesCarouselProps = HTMLAttributes<HTMLDivElement> & {
  prizes?: PrizeItem[];
  useMockData?: boolean;
};

export const MyPrizesCarousel = ({
  className,
  prizes,
  useMockData = false,
}: MyPrizesCarouselProps) => {
  const rawPrizes =
    useMockData || !prizes || prizes.length === 0 ? MY_PRIZES_VALUES : prizes;

  const displayPrizes = useMemo(() => processPrizesWithBigGain(rawPrizes), [rawPrizes]);

  return (
    <section className="flex flex-col items-center w-full gap-1 md:[&>div:last-child>div:first-child]:-left-2 md:[&>div:last-child>div:nth-child(4)]:-right-2">
      <div className="relative w-full md:isolate md:z-[1] md:flex md:justify-center md:mt-[8vh] md:min-h-0">
        <h3 className="text-xs font-bold text-primary-foreground relative md:!z-[-1] md:!relative text-center">
          PRÊMIOS DISPONÍVEIS
        </h3>
      </div>

      <Carousel
        className={cn(
          'md:-mx-2 md:[&>button:first-child]:ml-2 md:[&>button:last-child]:mr-2 px-2 md:px-0',
          className,
        )}
      >
        {displayPrizes.map((item, index) => (
          <Button
            key={index}
            variant="primary"
            size="large"
            className={cn(
              '!bg-white border-2 border-primary/10 text-foreground hover:!bg-white hover:!opacity-100 active:!bg-white focus:!bg-white rounded-md min-w-28 md:min-w-28 mb-2 relative',
              item.is_big_gain
                ? '!border-2 !border-primary animate-pulse-glow h-auto min-h-[56px] py-2'
                : 'h-14',
            )}
          >
            <div className="flex flex-col items-center justify-center w-full">
              <span className="text-center leading-tight">{item.value}</span>
              {item.is_big_gain && (
                <div className="absolute h-5 flex items-center justify-center px-2 rounded-md z-10 -bottom-2.5 left-1/2 -translate-x-1/2 bg-secondary text-2xs text-white font-bold whitespace-nowrap">
                  GRANDE GANHO
                </div>
              )}
            </div>
          </Button>
        ))}
      </Carousel>
    </section>
  );
};
